export default __webpack_public_path__ + "static/media/icons-poll.b66f213a.svg";